import React from "react";

import * as S from "./styles";

import Chart from "react-apexcharts";
import {
  CustomChartContainer,
  CustomChartHeader,
  CustomChartTitle,
} from "../styles";
import { CircularProgress } from "@mui/material";

var options = {
  chart: {
    id: "chart-produtividade",
    type: "donut",
    zoom: { enabled: false },
    toolbar: { show: false },
  },
  colors: ["#F27024", "#29B6F6", "#7AC943"],
  dataLabels: {
    enabled: true,
    formatter: function (val, { seriesIndex, w }) {
      return w.config.series[seriesIndex];
    },
    style: {
      fontSize: "14px",
      fontWeight: "bold",
      colors: ["#F27024", "#29B6F6", "#7AC943"],
    },
    dropShadow: {
      enabled: false,
    },
  },
  legend: {
    show: true,
    position: "right",
    fontSize: "14px",
    labels: {
      colors: "#000",
    },
    markers: {
      width: 10,
      height: 10,
      radius: 12,
    },
    itemMargin: {
      horizontal: 10,
      vertical: 5,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
  },
  stroke: {
    show: false,
  },
  tooltip: {
    enabled: true,
    shared: false,
    followCursor: true,
  },
  labels: ["Criação", "Edição", "Ativação/Desativação"],
};

const ProdutividadeGraphic = ({ data, isLoadingData }) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 643,
      }}
    >
      <CustomChartContainer>
        <CustomChartHeader>
          <CustomChartTitle>Produtividade</CustomChartTitle>
        </CustomChartHeader>
        <S.ChartWrapper id="produtividade-container">
          {isLoadingData ? (
            <CircularProgress style={{ color: "#F9922A" }} thickness={5} />
          ) : (
            <Chart
              options={{
                ...options,
                // xaxis: {
                //   categories: data.xaxis.categories,
                // },
              }}
              // series={data.series}
              series={data}
              width="100%"
              type="donut"
              height={410}
            />
          )}
        </S.ChartWrapper>
      </CustomChartContainer>
    </div>
  );
};

export default ProdutividadeGraphic;
